<template>
	<div class="container">
		<div class="main" v-if="show">

			<div class="top">
				<div class="img">
					<img style="width: 50px; height: 50px" :src="url" fit="contain" />
				</div>
				<span class="tit">支付宝收款</span>
				<span class="price">¥{{orderInfoPrice}}</span>
				<div class="desc">
					<span>收款说明：</span>
					<span>1、请使用【收款人】本人支付宝收款，且支付宝需要实名认证及绑定银行卡。</span>
					<span>2、若本人支付宝无法收款，请联系店员处理。</span>

				</div>
			</div>

			<div class="bottom">
				<div @click="handleAuth" :class="['code', { 'loading': loading }]" :style="{ opacity: loading ? 0.7 : 1 }">
					{{ loading ? '正在收款中，请耐心等待...' : '授权支付宝收款' }}
				</div>
			</div>

		</div>
		<div class="main1" v-if="!show &&!show_poup">
			<div class="img">
				<img style="width: 108px; height: 100px" :src="statu==1?success:fail" fit="contain" />
			</div>
			<div class="tit">{{statu==1 ? '收款成功' : '收款失败'}}</div>
			<div class="desc" v-if="statu==2">
				请确认支付宝是否绑定【收款人】姓名的本人银行卡及已实名
			</div>
		</div>

		<div v-if="show_poup" @click="close" class="mask"></div>

		<div v-if="show_poup==1">
			<div class="poup">
				<div class="title">
					<div class="tit">支付宝收款提示</div>
					<img src="@/assets/close.png" alt="" class="close"  @click="close"  style="width: 10px;height: 10px;" >
				</div>
				<div class="desc">打开支付宝APP，扫描收款码，进行授权完成收款</div>
				<div class="img">
					<img style="width: 100%; height: 440px" :src="url_tip" fit="contain" />
				</div>
				<div class="bottom">
					<div @click="openAlipay" class="code">打开支付宝</div>
				</div>
			</div>
		</div>

		<div v-else-if="show_poup==2">
			<div class="poup_tip">
				<div class="desc">拒绝授权将无法收款</div>
				<div class="btns">
					<div @click="close" class="btn_1">取消</div>
					<div @click="reset_auth" class="btn_2">重新授权</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		getOrderByorderID,
		getAliPayopenID,
		getMoneyByAliPayID,
		queryAnQuanFaIsOpen,
		getMoneyByAliPayID2,
		alipayCancelReturnPayment
	} from "@/api/index"
	import { safeSendType } from "@/config"

	export default {
		name: "AuthToken",
		data() {
			return {
				// safeSendType: '',
				url: require('@/assets/alipay.png'),
				url_tip: require('@/assets/tip.png'),

				show_poup: 0, // 1 2

				orderId: null, // 二维码跳转地址携带的orderId
				orderInfoPrice: 0.00, // 价格
				totalMoney: 0, // 总金额

				appId: '2021005132665908', // 替换为实际应用ID
				show :true,
				success: require('@/assets/success.png'),
				fail: require('@/assets/fail.png'),
				statu: 1, // 1-成功 2-失败
				loading: false, // 添加加载状态
				id: null,
				nowUserId: null,
				agree: null,

			}
		},
		created() {
			document.title = '收款';
			this.orderId = this.$route.query.orderId
			this.id = this.$route.query.id
			this.nowUserId = this.$route.query.nowUserId
			this.agree = this.$route.query.agree
			this.totalMoney = this.$route.query.totalMoney
			
			// this.queryAnQuanFaIsOpen()
			this.loadSDK()
		
		
		},
		mounted() {},
		methods: {
			queryAnQuanFaIsOpen(){
				queryAnQuanFaIsOpen(this.orderId).then(res => {
					console.log("queryAnQuanFaIsOpen - - - ", res);
					if(res.code == 200){
						
						this.safeSendType = res.data
						// this.$message.error('safeSendType:'+this.safeSendType);
				
					}
				})
			},
			async loadSDK() {

				try {
					// this.$message.error('初始化开始');
					await this.loadAlipaySDK();

					const data = await this.getOrderInfo();
					if (!data) {
						return;
					}

					//this.handleAuth();

				} catch (error) {
					this.$message.error('初始化失败，请重试');
				}
			},

			async getOrderInfo() {
				return new Promise((resolve, reject) => {
					if (this.orderId) {
					
						getOrderByorderID(this.orderId).then(res => {
							if(this.totalMoney==0){
								this.orderInfoPrice = res.data.data
							}else{
								this.orderInfoPrice = this.totalMoney
							}
							resolve(true)
						}).catch(err => {
							resolve(false)
					
							this.$message.error('查询订单信息接口报错，请联系管理员');
						})
					} else {
						resolve(false)
						
						this.$message.error('当前转账未查出订单信息，请联系管理员');
					}
				})
			},

			close() {
				this.show_poup = 0
			},
			reset_auth() {
				this.close()
				// 重新授权
				this.handleGetAuthCode()
			},
			async handleAuth() {
				if (this.loading) return; // 防止重复点击
				
				this.loading = true; // 设置加载状态
				
				try {
					if (!this.isAlipayClient()) {
						this.$message.error('请在支付宝客户端打开');
						this.show_poup = 1;
						this.loading = false; // 重置加载状态
						return;
					}

					await this.handleGetAuthCode();
				} catch (error) {
					console.error('授权失败:', error);
					this.loading = false; // 重置加载状态
				} finally {
					// 注意：这里不重置loading，因为handleGetAuthCode是异步回调，会在回调中处理
				}
			},

			isAlipayClient() {
				const ua = navigator.userAgent.toLowerCase()
				return ua.indexOf('alipayclient') > -1
			},

			// 打开支付宝
			openAlipay() {
				const appScheme = 'alipays://platformapi/startapp?appId=20000067&url=' + encodeURIComponent(window.location.href);
				const downloadUrl = {
					ios: 'https://apps.apple.com/cn/app/alipay/id333206289',
					android: 'market://details?id=com.eg.android.AlipayGphone'
				};

				// 尝试唤醒应用
				if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
					// iOS处理方案
					const iframe = document.createElement('iframe');
					iframe.style.display = 'none';
					iframe.src = appScheme;
					document.body.appendChild(iframe);

					setTimeout(() => {
						document.body.removeChild(iframe);
						// 检测是否跳转成功
						if (!document.hidden) {
							window.location.href = downloadUrl.ios;
						}
					}, 1000);
				} else {
					// Android处理方案
					try {
						window.location.href = appScheme;
						setTimeout(() => {
							if (!document.hidden) {
								window.location.href = downloadUrl.android;
							}
						}, 2000);
					} catch (e) {
						window.location.href = downloadUrl.android;
					}
				}
			},

			// 动态加载支付宝SDK
			loadAlipaySDK() {
				return new Promise((resolve) => {
					if (window.ap) {
						resolve();
						return;
					}

					const script = document.createElement('script');
					script.src = 'https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.min.js';
					script.onload = () => resolve();
					document.head.appendChild(script);
				});
			},

			// 支付宝授权
			async handleGetAuthCode() {
				if (!window.ap) {
					alert("支付宝SDK加载失败, 请刷新页面重新加载");
					this.loading = false; // 重置加载状态
					return;
				}
				const nonce = Date.now();
				ap.getAuthCode({
					appId: this.appId,
					scopes: ['auth_user'],
					customParams: {nonce}
				}, (res) => {
					if (res.authCode) {
						// 成功获取授权码
						this.handleAuthSuccess(res.authcode?res.authcode:res.authCode);
					} else {
						// 处理授权失败
						this.handleAuthError(res);
					}
					ap.removeStorageSync('alipay_auth_state');
				});
			},

			// 授权成功处理
			async handleAuthSuccess(authCode) {
				try {
					// 调用接口 获取openID
					const openID = await this.getOpenId(authCode)
					if (!openID) {
						this.loading = false; // 重置加载状态
						return
					}
					// 调用接口：发起收款
					const result = await this.getMoneyByOpenID(openID)
					this.show = false
					if (!result) {
						this.statu = 2
						document.title = '收款失败';
						this.loading = false; // 重置加载状态
						return
					}
					document.title = '收款成功' 
					this.statu = 1
					this.loading = false; // 重置加载状态
				} catch (error) {
					console.error('收款处理失败:', error);
					this.loading = false; // 重置加载状态
				}
			},

			// 授权失败处理
			handleAuthError(error) {
				let message = '授权失败，请重试';

				if (error.error === '4') {
					message = '用户拒绝授权';
					this.show_poup = 2;
				} else if (error.error === '2') {
					message = '无效参数';
				}
				
				this.loading = false; // 重置加载状态
			},

			// 通过auth_code获取openId
			async getOpenId(code) {
				return new Promise((resolve, reject) => {
				
					getAliPayopenID(code).then(res => {
						resolve(res.data.msg)
					}).catch(err => {
						alert("获取openID接口错误，请联系管理员")
						resolve(null)
					})
				})
			},


			// 通过openId发起收款
		async getMoneyByOpenID(code) {
			return new Promise((resolve, reject) => {
				// this.$message.error('收款');
				// if(this.safeSendType == 0){

					// agree不为空时，调用差异订单取消/退收款接口
					// alert('agree:'+this.agree+',id:'+this.id+',code:'+code+',nowUserId:'+this.nowUserId)
					if (this.agree !== null && this.agree !== undefined && this.agree !== '') {
						// alert('alipayCancelReturnPayment'+alipayCancelReturnPayment)
						alipayCancelReturnPayment(this.id, code, this.nowUserId, this.agree).then(res => {
							console.log("alipayCancelReturnPayment - - - ", res);
							// alert(JSON.stringify(res.data))
							if (res.data.code == 200)
								resolve(true)
							else resolve(false)
						}).catch(err => {
							alert("差异订单收款接口错误，请联系管理员")
							resolve(false)
						})
					} else {
						getMoneyByAliPayID(code,this.orderId).then(res => {
							console.log("getMoneyByAliPayID - - - ", res);
							if (res.data.code == 200)
								resolve(true)
							else resolve(false)
						}).catch(err => {
							alert("商家转账接口错误，请联系管理员")
							resolve(false)
						})
					}
				// }else{
				// 	getMoneyByAliPayID2(code,this.orderId).then(res => {
				// 		console.log("getMoneyByAliPayID - - - ", res);
				// 		if (res.data.code == 200)
				// 			resolve(true)
				// 		else resolve(false)
				// 	}).catch(err => {
				// 		alert("商家转账接口错误，请联系管理员")
				// 		resolve(false)
				// 	})

				// }
			})

		}


		}
	}
</script>

<style scoped>
	.container {
		width: 100%;
		height: 96vh;
		box-sizing: border-box;
		margin: 0;
		padding: 0;
		background-color: #FFF;
		z-index: 1;
	}

	.main {
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		padding: 20px 10px;
		margin: 0;
		overflow: hidden;
		z-index: 2;
	}
	.main1 {
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 20px 10px;
		margin: 0;
		overflow: hidden;
		z-index: 2;
	}

	.top {
		width: 100%;
		height: auto;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		padding-top: 36px;
	}

	.top .img {
		width: 100%;
		height: 50px;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;

	}

	.top .tit {
		color: rgb(51, 51, 51);
		font-family: 思源黑体;
		font-size: 16px;
		font-weight: 500;
		line-height: 18px;
		letter-spacing: 0px;
		text-align: center;
	}

	.top .price {
		box-sizing: border-box;
		margin: 30px 0 81px 0;
		color: rgb(255, 89, 70);
		font-family: 思源黑体;
		font-size: 36px;
		font-weight: 400;
		letter-spacing: 0px;
	}

	.top .desc {
		width: 100%;
		height: auto;
		box-sizing: border-box;
		border-radius: 4px;
		background: rgb(255, 245, 245);
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		flex-wrap: nowrap;
		padding: 10px 0;

		color: rgb(251, 51, 42);
		font-family: 思源黑体;
		font-size: 14px;
		font-weight: 400;
		letter-spacing: 0px;
	}

	.bottom {
		width: 100%;
		height: 67px;
		/* background-color: red; */
		padding: 10px 26px;
		box-sizing: border-box;
	}

	.bottom .code {
		width: 100%;
		height: 37px;
		border-radius: 42px;
		box-sizing: border-box;
		background: rgb(6, 180, 253);
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: nowrap;
		transition: all 0.3s ease; /* 添加过渡效果 */

		color: rgb(255, 255, 255);
		font-family: 思源黑体;
		font-size: 14px;
		font-weight: 500;
		letter-spacing: -0.33px;
	}

	.bottom .code.loading {
		background: rgb(150, 150, 150); /* 加载时的颜色 */
		cursor: not-allowed; /* 禁用鼠标样式 */
	}

	.bottom .code:active:not(.loading) {
		transform: scale(0.98); /* 点击时的缩放效果 */
	}

	.mask {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 5;
		background: rgba(0, 0, 0, 0.3);
	}

	.poup {
		width: 100%;
		height: auto;
		position: absolute;
		bottom: 0;
		left: 0;
		box-sizing: border-box;
		background-color: #FFF;
		border-radius: 4px;
		padding: 10px 34px;
		z-index: 10;
	}

	.poup .title {
		width: 100%;
		/* height: 48px; */
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: nowrap;
		position: relative;
	}

	.poup .title .tit {
		color: rgb(51, 51, 51);
		font-family: 思源黑体;
		font-size: 16px;
		font-weight: 500;
		letter-spacing: 0px;
	}

	.poup .title .close {
		position: absolute;
		/* top: -2px; */
		right: 0;
		color: #5C5C5C;
		font-size: 18px;
	

	}

	.poup .desc {
		width: 100%;
		color: rgb(255, 89, 70);
		font-family: 思源黑体;
		font-size: 14px;
		font-weight: 400;
		letter-spacing: 0px;
		text-align: center;
		margin: 12px 0;
		box-sizing: border-box;
	}

	.poup .img {
		width: 100%;
		height: auto;
	}

	.poup .bottom {
		width: 100%;
		height: 67px;
		/* background-color: red; */
		padding: 10px 26px;
		box-sizing: border-box;
	}

	.poup .bottom .code {
		width: 100%;
		height: 37px;
		border-radius: 42px;
		box-sizing: border-box;
		background: rgb(6, 180, 253);
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: nowrap;

		color: rgb(255, 255, 255);
		font-family: 思源黑体;
		font-size: 14px;
		font-weight: 500;
		letter-spacing: -0.33px;
	}

	.poup_tip {
		position: absolute;
		width: 80%;
		/* height: 100px; */
		top: 43vh;
		left: 10%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		box-sizing: border-box;
		background-color: #FFF;
		border-radius: 4px;
		padding: 0 10px 12px 10px;
		z-index: 10;
	}

	.poup_tip .desc {
		width: 100%;
		display: flex;
		justify-content: center;
		flex-wrap: nowrap;
		box-sizing: border-box;
		margin: 30px 0;

		color: rgb(51, 51, 51);
		font-family: 思源黑体;
		font-size: 16px;
		font-weight: 500;
		letter-spacing: -0.33px;
	}

	.poup_tip .btns {
		width: 100%;
		height: 36px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: nowrap;
	}

	.poup_tip .btns>div {
		width: 48%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: nowrap;
		box-sizing: border-box;
		border-radius: 5px;

		font-family: 思源黑体;
		font-size: 14px;
		font-weight: 500;
		letter-spacing: -0.33px;
	}

	.poup_tip .btns .btn_1 {
		color: #333333;
		border: 1px solid rgb(221, 221, 221);
		background: rgb(255, 255, 255);
	}

	.poup_tip .btns .btn_2 {
		color: #fff;
		border: none;
		background: rgb(6, 180, 253);
	}

	.img {
		width: 108px;
		height: 100px;
		box-sizing: border-box;
	}

	.tit {
		color: rgb(0, 0, 0);
		font-family: 思源黑体;
		font-size: 20px;
		font-weight: 400;
		letter-spacing: 0px;
		margin: 5px 0;
	}

	.desc {
		width: 60%;
		height: auto;
		box-sizing: border-box;

		color: rgb(133, 133, 133);
		font-family: 思源黑体;
		font-size: 12px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 18px;
		text-align: center;
	}
</style>